import React, { useState } from 'react';
import { Data, DataState } from '../../types/data-providers';
import { useAuthHelper } from '../../components/AuthContextProvider';
import * as ApiRequests from '../../api/requests';
import { ApiResponse } from '../../api/api-request-helpers';
import { ChildProfileDetailsOkResponse, GenericNotOkResponse } from '../../api/types';

type ProfileData = {
    profiles: Data<any>;
    getChildProfileData: Function;
};

const Context = React.createContext<ProfileData | null>(null);


function useChildProfileDetails(): ProfileData {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useChildProfileDetails must be used within a ChildProfileDetailsProvider');
    }
    return contextState;
}

const ChildProfileDetailsProvider: React.FC<{ orgId: string; deviceprofileId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const [profiles, setProfiles] = useState<Data<any>>({ state: DataState.Loading });

    const getDataByAPI = async (
        organizationId: string,
        deviceprofileId: string
    ): Promise<ApiResponse<ChildProfileDetailsOkResponse, GenericNotOkResponse>> => {
        const childProfileResult = await ApiRequests.childProfileDetails(
            {
                organizationId: organizationId,
                deviceprofileId: deviceprofileId,
            },

            { authHelper }
        );
        return childProfileResult;
    };

    const getChildProfileData = async (organizationId: string, deviceprofileId: string): Promise<void> => {
        setProfiles({
            state: DataState.Loading,
        });
        const childProfileResult = await getDataByAPI(organizationId, deviceprofileId);
        const result = childProfileResult.ok
            ? setProfiles({
                  state: DataState.Loaded,
                  value: childProfileResult.response.data,
              })
            : setProfiles({
                  state: DataState.Error,
                  errorMessage: ApiRequests.extractErrorCodeWithMessage(childProfileResult.response),
              });
        console.error(result);
        return result;
    };
    return <Context.Provider value={{ profiles, getChildProfileData }}>{props.children}</Context.Provider>;

};

const TestStarfishChildDeviceDataProvider: React.FC<{ value: ProfileData }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { ChildProfileDetailsProvider, TestStarfishChildDeviceDataProvider, useChildProfileDetails };
